var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-widget-box"},[_c('video',{staticClass:"livevideo",attrs:{"id":"livedemo","controls":"","preload":"auto"}},[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }